import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

// ============================================================
// cn() - utility canonica de shadcn-svelte para combinar clases
// Tailwind respetando merge inteligente (la ultima clase del mismo
// utility group gana, ej "p-2 p-4" -> "p-4").
// ============================================================
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
